module.exports = __webpack_public_path__ + "img/mitsui-fudosan-logo.11ab8c6b.gif";